import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '460px',
    height: '220px',
    [theme.breakpoints.down('xs')]: {
      height: '100%',
      minWidth: 0,
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.header.main,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  actionButton: {
    margin: theme.spacing(3),
  },
  actionButtons: {
    marginTop: '-6px',
  },
  saveButton: {
    backgroundColor: '#fc6161',
    color: '#fff',
  },
}));

const CardCopy = ({ visible, card, dismiss, confirm, copy }) => {
  const classes = useStyles();
  const modalTitle = 'Copy Selected Credential?';
  const [cardDataChecked, setCardDataChecked] = useState(true);
  const [accessDataChecked, setAccessDataChecked] = useState(true);
  return (
    <Modal className={classes.modal} open={visible}>
      <div className={classes.paper}>
        <h2 style={{ marginTop: '24px' }}>{modalTitle}</h2>
        <span>
          <Typography style={{ marginBottom: '10px' }}>
            Select the data you wish to copy to a new card.
          </Typography>
        </span>
        <div>
          <span>
            <FormControlLabel
              control={
                <Checkbox
                  checked={cardDataChecked}
                  onChange={() => setCardDataChecked(!cardDataChecked)}
                  name="cardData"
                  color="secondary"
                />
              }
              label="Card Data"
            />
          </span>
          <span>
            <FormControlLabel
              control={
                <Checkbox
                  checked={accessDataChecked}
                  onChange={() => setAccessDataChecked(!accessDataChecked)}
                  name="accessData"
                  color="secondary"
                />
              }
              label="Access Data"
            />
          </span>
        </div>
        <div className={classes.actionButtons}>
          <Button
            className={classes.actionButton}
            onClick={() => {
              dismiss();
            }}
          >
            Cancel
          </Button>
          <Button
            className={[classes.actionButton, classes.saveButton]}
            variant="contained"
            style={{ backgroundColor: '#5ba9e1', color: '#fff' }}
            onClick={() => {
              const copyDetail = {
                cardData: cardDataChecked,
                accessData: accessDataChecked,
              };
              copy(copyDetail);
            }}
          >
            Copy
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CardCopy;
